<template>
    <q-btn
        :color="secondary ? undefined: 'accent'"
        :flat="secondary"
        icon="add"
        :label="what ? $t(`add_what`, { what }) : $t('add')"
        no-caps
    >
        <template v-if="tooltip">
            <q-tooltip>{{ tooltip }}</q-tooltip>
        </template>
    </q-btn>
</template>

<script setup>
defineProps({
    what: String,
    secondary: Boolean,
    tooltip: String,
})
</script>
